<div id="sub-page-nav" [ngClass]="{'disabled': disabled}">
  <div class="mobile-navigation">
    <app-dropdown-list header="Navigation">
      <app-dropdown-list-item
        *ngFor="let subPage of subPages"
        name="{{subPage.title}}"
        (click)="togglePanel(subPage.id)">
      </app-dropdown-list-item>
    </app-dropdown-list>
  </div>
  <div class="desktop-navigation">
    <div class="navigation">
      <span class="navigation__header">NAVIGATION</span>
      <span
        *ngFor="let subPage of subPages"
        id="sub-page-nav.{{subPage.id}}"
        class="navigation__tab"
        [ngClass]="{'navigation__tab--selected': subPage.selected}"
        [ngStyle]="{'font-style': subPage.form && subPage.form.dirty ? 'italic' : 'normal'}"
        (click)="togglePanel(subPage.id)">
        {{subPage.title}}
      </span>
    </div>
  </div>
</div>
